<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                    <b-overlay :show="formLoader">
                    <b-row>
                        <b-col xl="12" lg="12" sm="12">
                            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset" enctype="multipart/form-data">
                                    <b-row>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Organization Name" vid="organization_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="organization_id "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="form_data.org_id"
                                                    id="organization_id"
                                                    :options="orgList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Institute Type" vid="institute_type_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="institute_type "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('ds_config.institute_type')}}  <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="form_data.office_type_id"
                                                    id="institute_type_id"
                                                    :options="officeTypeList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                           <ValidationProvider name="Institute Name" vid="institute_name" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="institute_name "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('ds_institute_management.institute_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="form_data.office_id"
                                                    id="institute_name"
                                                    :options="officeList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Trainee Type" vid="trainee_type" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="trainee_type"
                                                slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{$t('ds_config.trainee_type')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                                id="trainee_type"
                                                plain
                                                v-model="form_data.trainee_type"
                                                :options="traineeTypeList"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                                <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                            </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                           <ValidationProvider name="Training Title" vid="training_title" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="training_title "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('training.training_title')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="form_data.training_id"
                                                    id="institute_name"
                                                    :options="trainingTitleList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                         <b-col lg="6" sm="12">
                                         <ValidationProvider name="From" vid='from' rules="required">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="from"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('training.from')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                placeholder="Select Date"
                                                id="from"
                                                v-model="form_data.from"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                        </b-col>
                                         <b-col lg="6" sm="12">
                                         <ValidationProvider name="To" vid='to' rules="required">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="to"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('training.to')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                placeholder="Select Date"
                                                id="to"
                                                v-model="form_data.to"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                        </b-col>
                                         <b-col lg="6" sm="12">
                                         <ValidationProvider name="Total Participant" vid='total_participant' rules="required">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="total_participant"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('training.total_participant')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                    type="number"
                                                placeholder="Total Participant"
                                                id="total_participant"
                                                v-model="form_data.total_participant"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                        </b-col>
                                        </b-row>
                                    <div class="row">
                                        <div class="col-sm-3"></div>
                                        <div class="col text-right">
                                        <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                            &nbsp;
                                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                        </div>
                                    </div>
                                </b-form>
                            </ValidationObserver>
                        </b-col>
                    </b-row>
                    </b-overlay>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
// import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { ParentTrainingAdd, ParentTrainingUpdate } from '../../api/routes.js'
import flatpickr from 'flatpickr'

export default {
    props: ['id', 'item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
    this.form_data.org_id = this.$store.state.dataFilters.orgId
    this.form_data.office_type_id = this.$store.state.dataFilters.officeTypeId
    this.form_data.office_id = this.$store.state.dataFilters.officeId
    if (this.form_data.office_id && this.form_data.trainee_type) {
        this.getTrainingTitle(this.form_data.trainee_type)
    }
       if (this.id) {
            this.institute_id = this.id
           this.form_data = this.item
           this.form_data.from = this.item.date_from
           this.form_data.to = this.item.date_to
           this.form_data.total_participant = this.item.total_participant
        }
    },
    mounted () {
        flatpickr('#from', {})
        flatpickr('#to', {})
        // core.index()
    },
    data () {
        return {
            ItemShow: false,
            formLoader: false,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            disabilitySchoolServiceBaseUrl: disabilitySchoolServiceBaseUrl,
            form_data: {
                org_id: 0,
                office_type_id: 0,
                office_id: 0,
                trainee_type: 0,
                training_id: 0,
                to: null,
                from: null,
                total_participant: null
            },
            officeTypeList: [],
            officeList: [],
            trainingTitleList: []
        }
    },
    computed: {
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        traineeTypeList: function () {
            return this.$store.state.DisabilitySchoolService.commonObj.traineeTypeList.map(el => {
                return Object.assign({}, el, { text: this.$i18n.locale === 'bn' ? el.text_bn : el.text_en })
            })
        },
        currentLocale () {
            return this.$i18n.locale
        }
    },
    watch: {
        'form_data.org_id': function (newVal) {
        this.officeTypeList = this.getofficeTypeList(newVal)
        },
        'form_data.office_type_id': function (newVal) {
        this.officeList = this.getOfficeList(newVal)
        },
        // 'form_data.office_id': function (newVal, oldVal) {
        //     if (newVal !== oldVal) {
        //         this.trainingTitleList = this.getTrainingTitle(newVal)
        //     }
        // },
        'form_data.trainee_type': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.trainingTitleList = this.getTrainingTitle(newVal)
            }
        }
    },
    methods: {
        getTrainingTitle (Id) {
            const officeId = this.form_data.office_id
            const training = this.$store.state.DisabilitySchoolService.commonObj.trainingTitleList.filter(item => item.status === 1)
            if (Id && officeId) {
                return training.filter(institute => institute.office_id === parseInt(officeId) && institute.trainee_type === Id)
            }
            return training
        },
        storeUpdate () {
             this.formLoader = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            const loadingState = { loading: false, listReload: false }
            var formData = new FormData()
            Object.keys(this.form_data).map(key => {
                if (key === 'image') {
                    formData.append(key, this.upload_image)
                } else {
                    formData.append(key, this.form_data[key])
                }
            })
            if (this.institute_id) {
                formData.append('_method', 'PUT')
                RestApi.postData(disabilitySchoolServiceBaseUrl, `${ParentTrainingUpdate}/${this.institute_id}`, formData)
                    .then(response => {
                        this.formLoader = false
                        this.$toast.success({
                            title: this.$t('globalTrans.success'),
                            message: this.institute_id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                            color: '#D6E09B'
                        })
                        this.$bvModal.hide('modal-4')
                        loadingState.listReload = true
                        this.$store.dispatch('mutateCommonProperties', loadingState)
                    })
            } else {
                RestApi.postData(disabilitySchoolServiceBaseUrl, ParentTrainingAdd, this.form_data)
                    .then(response => {
                        this.formLoader = false
                        this.$toast.success({
                            title: this.$t('globalTrans.success'),
                            message: this.institute_id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                            color: '#D6E09B'
                        })
                        this.$bvModal.hide('modal-4')
                        loadingState.listReload = true
                        this.$store.dispatch('mutateCommonProperties', loadingState)
                })
            }
        },
        getofficeTypeList (orgId = null) {
            const instituteTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0)
            if (orgId) {
                return instituteTypeList.filter(institute => institute.org_id === orgId)
            }

            return instituteTypeList
        },
        getOfficeList (typeId = null) {
            const instituteList = this.$store.state.commonObj.officeList.filter(item => item.status === 0)
            if (typeId) {
                return instituteList.filter(institute => institute.office_type_id === typeId)
            }

            return instituteList
        }
    }
}

</script>
